import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Homepage from '../Homepage';
import PostPage from '../PostPage';
import PostList from '../PostList';

import './index.scss';
import ReactGA from '../ga';
import $ from 'jquery';

const fadeConfig = { stiffness: 100, damping: 10 };

const trackGA = () => {
  ReactGA.pageview(window.location.pathname + window.location.search + window.location.hash);
}

class App extends Component {
  componentDidMount() {
    var promise = this.props.loadData();
    trackGA();
  }

  componentDidUpdate() {
    trackGA();
  }

  render() {
    return (
      <BrowserRouter>
        <Route render={({location, history, match}) => {
          return (
            <div className="app">
              <Navbar location={location}/>
              <Sidebar />
              <Switch>
                <Route exact path="/" component={Homepage}/>
                <Route exact path="/post" component={PostPage}/>
                <Route exact path="/posts" component={PostList}/>
              </Switch>
            </div>
          )
        }} />
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/pure.js